import "./gastos.css";

export { default as Listado } from "./Listado";
export { default as Crear } from "./Crear";
export { default as Detalle } from "./Detalle";
